import type { IxcCostbasisV1TaxLotKeys } from '@interxfi/types';
import { type EntityPathBuilder, getResolvedPath } from '../../../util/routing/entity-paths';

export const getCostBasisTaxLotPath: EntityPathBuilder<IxcCostbasisV1TaxLotKeys> = (context) => {
  switch (context.kind) {
    case 'list':
      if (!context?.keys) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/asset/$assetId/tax-lot', context.keys);
    case 'detail': {
      if (!context?.keys?.taxLotId) {
        return undefined;
      }

      return getResolvedPath('/registration/account/$accountId/asset/$assetId/tax-lot/$taxLotId', context.keys);
    }
  }
};
